import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar, MCList } from '../components';
import marketCoins from '../data/marketCap.json';
import { mapCapCoin } from '../utils';

const coins = marketCoins.map(coin => mapCapCoin(coin));

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

const MarketCap = ({ theme }) => (
  <Screen theme={theme} title="MarketCap">
    <TopNavBar title="Market Cap" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <MCList coins={coins} />
    </Content>
    <BottomTabBar selected="marketcap" />
  </Screen>
);

export default withTheme(MarketCap);



// WEBPACK FOOTER //
// ./src/screens/MarketCap.js